import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './international.json';

const initInternationalInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['InternationalController/initInternationalInfo'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('InternationalController/initInternationalInfo'),
    withScenario(withAuthCheck(initInternationalInfo))
  ),
];
